// company routes
import baseRoute from '../CompanyPage/route';

const route = (id = ':id') => `${baseRoute(id)}/weather`;

export default route;
